export default __webpack_public_path__ + "static/media/gtd6.bee585ae.jpg";